<div class="payment-agreement-term justify-content-center h-100">
    <div class="content h-100">        
        <h2 [innerHtml]="'pt.edp.edponline.payment.agreement.term.installments' | translate: { INSTALLMENTS: paymentAgreementTerm?.data.installments }"></h2>
        <div class="content-wrapper content-col">
            <div class="block">
                <p class="content-title" [innerHtml]="'pt.edp.edponline.payment.agreement.term.subtitle.first.months' | translate: { FIRSTMONTHS: paymentAgreementTerm?.data.firstValue }"></p>
                <p class="content-description">
                    {{ "pt.edp.edponline.payment.agreement.term.description.left" | translate }}  
                </p>
            </div>
            <div class="content-line"></div>
            <div class="block">
                <p class="content-title" [innerHtml]="'pt.edp.edponline.payment.agreement.term.subtitle.value.months' | translate: { VALUEMONTHS: paymentAgreementTerm?.data.value }"></p>
                <p class="content-description">
                    {{ "pt.edp.edponline.payment.agreement.term.description.right" | translate }}
                </p>
            </div>
        </div>
    </div>
    <div class="custom-buttons">
        <div>
            <button class="custom-button-outline" (click)="redirect('decline')">
                {{ "pt.edp.edponline.payment.agreement.term.buttom.decline" | translate }} 
            </button>
            <button class="custom-buttom" (click)="redirect('accept')">
                {{ "pt.edp.edponline.payment.agreement.term.buttom.accept" | translate }}                
            </button>
        </div>
        <p class="custom-observation" [innerHTML]="'pt.edp.edponline.payment.agreement.term.observation' | translate: { TIMER: timer }"> </p>
    </div> 
</div>